<template>
  <section class="process-section">
    <div class="core-container">
      <div class="process-section__steps">
        <div
          v-for="(step, index) in steps"
          :key="step.no"
          class="process-section__step-wrap"
        >
          <div class="process-section__step">
            <div class="process-section__icon">{{ step.no }}</div>
            <div class="process-section__text">
              <p class="process-section__title">{{ step.no }} {{ step.title }}</p>
              <p class="process-section__subtitle">{{ step.subtitle }}</p>
            </div>
          </div>
          <span
            v-if="index < steps.length - 1"
            class="process-section__arrow"
          >→</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { PROCESS_STEPS } from '@/mock/home'

export default {
  name: 'ProcessSteps',
  data() {
    return {
      steps: PROCESS_STEPS
    }
  }
}
</script>

<style scoped>
.process-section {
  padding: 0 0 var(--space-2xl);
  background: transparent;
}

.process-section__steps {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--color-bg-page);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-panel);
  padding: var(--space-lg) var(--space-xl);
}

.process-section__step-wrap {
  display: flex;
  align-items: center;
  flex: 1;
}

.process-section__step {
  display: flex;
  align-items: center;
  gap: var(--space-md);
  flex: 1;
}

.process-section__icon {
  width: 56px;
  height: 56px;
  flex-shrink: 0;
  border-radius: 50%;
  background: var(--color-primary-light);
  color: var(--color-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--font-size-sm);
  font-weight: 700;
}

.process-section__title {
  font-size: var(--font-size-md);
  font-weight: 600;
  color: var(--color-primary);
}

.process-section__subtitle {
  font-size: var(--font-size-xs);
  color: var(--color-text-muted);
  letter-spacing: 1px;
  margin-top: var(--space-xs);
}

.process-section__arrow {
  color: var(--color-text-muted);
  font-size: var(--font-size-lg);
  padding: 0 var(--space-md);
  flex-shrink: 0;
}
</style>
